export enum RecordingType {
	CLOUD = 'cloud',
	LOCAL = 'local',
}

export enum RecordingMediaType {
	VIDEO = 'video',
	IMAGE = 'image',
}

export interface CloudRecordingClassificationObject {
	name: string;
	score: number;
	model?: string;
	/** [x1, y1, x2, y2] in source image pixel coordinates */
	boundingBox?: [number, number, number, number];
}

export interface CloudRecordingClassification {
	objects: CloudRecordingClassificationObject[];
	elapsedMs?: number;
}

export interface CloudRecording {
	id: string;
	mac: string;
	date: string; // ISO date string
	event: string;
	type: RecordingMediaType;
	imageUrls?: {
		small: string;
		medium: string;
		large: string;
	};
	classification?: CloudRecordingClassification;
}

export interface CloudRecordingImage extends CloudRecording {
	type: RecordingMediaType.IMAGE;
}

export interface CloudRecordingVideo extends CloudRecording {
	type: RecordingMediaType.VIDEO;
	videoUrl: string;
}

export interface CloudRecordingResponse {
	items: CloudRecording[];
	limit: number;
	offset: number;
	total: number;
}

export interface CloudRecordingParams {
	date?: string; // ISO date string (YYYY-MM-DD)
	offset?: number;
	limit?: number;
}

export interface CloudRecordingDayOverview {
	date: string; // calendar day (UTC), YYYY-MM-DD
	videos: number;
	bytes: number | null; // reserved placeholder, currently always null
	duration: number | null; // reserved placeholder, currently always null
}

export interface CloudRecordingOverviewResponse {
	days: CloudRecordingDayOverview[];
}

export enum CloudMediaEncryption {
	ENCRYPTED = 'ENCRYPTED',
	NONE = 'NONE',
}

export interface CloudMediaSettings {
	encryption?: CloudMediaEncryption | string;
}

export type CloudLatestImageType = 'small' | 'medium' | 'large';

export interface CloudLatestImage {
	small: string;
	medium: string;
	large: string;
}

export interface CloudLatestImageData {
	[deviceId: string]: CloudLatestImage;
}

export interface CloudLatestImagesResponse {
	data: CloudLatestImageData;
}

/**
 * Response from GET /auth/gstorage
 * Contains a signed token for temporary read access to user's recording directory
 */
export interface GStorageSignedUrlResponse {
	token: string;
	expiresIn: number; // Seconds until expiration
}
